import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '../../../definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'risk-profil-company-first-part-form',
    templateUrl: './risk-profil-company-first-part-form.component.html',
    styleUrls: ['./risk-profil-company-first-part-form.component.scss'],
    standalone: false
})
export class RiskProfilCompanyFirstPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    {
      value: 'SPA',
      label: 'Société par actions',
    },
    {
      value: 'SDP',
      label: 'Société de personnes',
    },
  ];
  options2: FormControlOption[] = [
    { value: 'LOWER_THAN_100K', label: 'Inférieur à 100k€' },
    { value: 'BETWEEN_100K_AND_500K', label: 'Entre 100k et 500k€' },
    { value: 'BETWEEN_500K_AND_1500K', label: 'Entre 500k et 1.5M€€' },
    { value: 'BETWEEN_1500K_AND_3000K', label: 'Entre 1.5Mk€ et 3M€' },
    { value: 'GREATER_THAN_3000K', label: 'Supérieur à 3M€' },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
